import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import VueLazyLoad from 'vue3-lazy'

const app = createApp(App).use(router)

app.use(VueLazyLoad, {
  loading: '/spinner.gif', // optional
})

app.mount('#app')